const contentSliders = document.querySelectorAll<HTMLElement>('.content-slider');

contentSliders.forEach((contentSlider) => {
	const isLarge = contentSlider.classList.contains('content-slider--large');
	new (window as Window).Swiper(contentSlider, {
		breakpoints: {
			300: {
				slidesPerView: isLarge ? 1 : 1.2,
				spaceBetween: 16,
			},
			768: {
				slidesPerView: isLarge ? 1 : 3.2,
				spaceBetween: 24,
			},
		},

		loop: false,
		navigation: {
			enabled: true,
			nextEl: contentSlider.querySelector('.content-slider__next') as HTMLElement,
			prevEl: contentSlider.querySelector('.content-slider__prev') as HTMLElement,
		},
	});
});
